import focusManager from "focus-manager";
import {ToggleScroll} from "@main/components/toggle-scroll";
/** Класс модального окна для подачи заявки на обучение. */
class SendRequestModal {
    /**
     * @type {{HTMLElement}} элемент модального окна.
     */
    modal = document.querySelector(".js-modal-send-request")

    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.openModalButton = this.el.querySelectorAll(".js-open-send-request-modal");
        this.listenEvents();
    }

    /**
     * Прослушиваем событие клика на кнопки "Написать" и "Подать документы"
     * 
     * @returns {void}
     */
    listenEvents() {
        this.openModalButton.forEach((el) => {
            el.addEventListener("click", () => {
                this.modal.classList.add("shown");
                ToggleScroll.disable(this.modal);
                focusManager.capture(this.modal);
            });
        });
    } 
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-program-learning").forEach((item) => new SendRequestModal(item));
});
